import { jsx as _jsx } from "react/jsx-runtime";
import { ReloadApplicationPrompt } from "~/components/ReloadApplication/components/ReloadApplicationPrompt";
import { useReloadApplication } from "~/providers/ReloadApplicationProvider";
export const ReloadApplication = ()=>{
    const { hasNewRelease, pendingActions, onReload } = useReloadApplication();
    if (hasNewRelease && !pendingActions.length) {
        return /*#__PURE__*/ _jsx(ReloadApplicationPrompt, {
            onReload: onReload
        });
    }
    return null;
};
